import React, { Fragment } from 'react';

import Star from '@/assets/star.svg?react';

interface Props {
  fill: number;
  color?: string;
  size?: number;
  keyProp?: string;
  rateMax?: number;
}

function calcFill(fill: number) {
  return Number(String(Math.ceil((fill % 1) * 100)));
}

const Stars = ({ fill, size = 24, keyProp = 'stars', rateMax = 5 }: Props) => {
  if (fill === rateMax) {
    return (
      <div className={'flex w-max pb-0.5'}>
        {[...Array(Math.floor(fill))].map((_, idx) => (
          <Fragment key={`${fill}star__${idx}`}>
            <Star className={'text-yellow-500'} width={size} />
          </Fragment>
        ))}
      </div>
    );
  }

  return (
    <div className={'flex w-max pb-0.5'}>
      {[...Array(Math.floor(fill))].map((_, idx) => (
        <Fragment key={`filled-star-${idx}`}>
          <Star className={'text-yellow-500'} width={size} />
        </Fragment>
      ))}
      {Math.ceil(fill) - fill !== 0 ? (
        <span key={`${fill}_2_${keyProp}`} className={'relative'}>
          <Star className={'text-yellow-500'} width={size} />
          <Star
            className={'absolute top-0 overflow-hidden text-dark-gray-200'}
            width={size}
            clipPath={`inset(0 0 0 ${calcFill(fill)}%)`}
          />
        </span>
      ) : (
        <Star className={'text-dark-gray-200'} width={size} />
      )}
      {[...Array(rateMax - Math.floor(fill + 1))].map((_, idx) => (
        <Fragment key={`star-gray-${idx}`}>
          <Star className={'text-dark-gray-200'} width={size} />
        </Fragment>
      ))}
    </div>
  );
};

export default Stars;
